import { render, staticRenderFns } from "./PengajuanCutiBaru.vue?vue&type=template&id=0b0835b4"
import script from "./PengajuanCutiBaru.vue?vue&type=script&lang=js"
export * from "./PengajuanCutiBaru.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports